var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg45(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 315.43 125.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#2f2bb2;}.cls-3{fill:#6e63fb;}.cls-4{opacity:0.2;}.cls-10,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-5{mix-blend-mode:multiply;}.cls-32,.cls-6{fill:#fff;}.cls-6{opacity:0;}.cls-7{fill:#2c51ff;}.cls-33,.cls-7{mix-blend-mode:screen;}.cls-8{fill:#3f3d55;}.cls-9{fill:#5552e2;}.cls-10,.cls-38{opacity:0.5;}.cls-11{fill:#f8f3f3;}.cls-11,.cls-39{opacity:0.05;}.cls-12{fill:#f2e7e7;}.cls-12,.cls-40{opacity:0.1;}.cls-13{fill:#ebdbdb;}.cls-13,.cls-41{opacity:0.14;}.cls-14{fill:#e5cfcf;}.cls-14,.cls-42{opacity:0.19;}.cls-15{fill:#dec3c3;}.cls-15,.cls-43{opacity:0.24;}.cls-16{fill:#d7b7b6;}.cls-16,.cls-44{opacity:0.29;}.cls-17{fill:#d1abaa;}.cls-17,.cls-45{opacity:0.33;}.cls-18{fill:#ca9f9e;}.cls-18,.cls-46{opacity:0.38;}.cls-19{fill:#c39392;}.cls-19,.cls-47{opacity:0.43;}.cls-20{fill:#bd8786;}.cls-20,.cls-48{opacity:0.48;}.cls-21{fill:#b67a7a;}.cls-21,.cls-49{opacity:0.52;}.cls-22{fill:#b06e6e;}.cls-22,.cls-50{opacity:0.57;}.cls-23{fill:#a96262;}.cls-23,.cls-51{opacity:0.62;}.cls-24{fill:#a25656;}.cls-24,.cls-52{opacity:0.67;}.cls-25{fill:#9c4a4a;}.cls-25,.cls-53{opacity:0.71;}.cls-26{fill:#953e3d;}.cls-26,.cls-54{opacity:0.76;}.cls-27{fill:#8e3231;}.cls-27,.cls-55{opacity:0.81;}.cls-28{fill:#882625;}.cls-28,.cls-56{opacity:0.86;}.cls-29{fill:#811a19;}.cls-29,.cls-57{opacity:0.9;}.cls-30{fill:#7b0e0d;}.cls-30,.cls-58{opacity:0.95;}.cls-31{fill:#740201;}.cls-33,.cls-34,.cls-35,.cls-36,.cls-37{opacity:0.3;}.cls-33{fill:url(#linear-gradient);}.cls-34{fill:url(#linear-gradient-2);}.cls-35{fill:url(#linear-gradient-3);}.cls-36{fill:url(#linear-gradient-4);}.cls-37{fill:url(#linear-gradient-5);}.cls-38{fill:url(#linear-gradient-6);}.cls-39{fill:#fcf4f3;}.cls-40{fill:#fae8e7;}.cls-41{fill:#f7dddb;}.cls-42{fill:#f4d1ce;}.cls-43{fill:#f1c6c2;}.cls-44{fill:#efbab6;}.cls-45{fill:#ecafaa;}.cls-46{fill:#e9a39e;}.cls-47{fill:#e79892;}.cls-48{fill:#e48c86;}.cls-49{fill:#e18179;}.cls-50{fill:#de756d;}.cls-51{fill:#dc6a61;}.cls-52{fill:#d95e55;}.cls-53{fill:#d65349;}.cls-54{fill:#d4473d;}.cls-55{fill:#d13c31;}.cls-56{fill:#ce3024;}.cls-57{fill:#cb2518;}.cls-58{fill:#c9190c;}.cls-59{fill:#c60e00;}.cls-60{fill:#2424a3;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1238.75,
    y1: 134.15,
    x2: -1238.75,
    y2: 131.24,
    gradientTransform: "translate(1241.66 -121.87) rotate(-0.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0a0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#230c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#4d1b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#882f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#d14800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1239.82,
    y1: 133.58,
    x2: -1239.57,
    y2: 133.58,
    gradientTransform: "translate(1241.66 -121.87) rotate(-0.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#e0bfbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#c48685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#ad5756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#9b3331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#8e1817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#870907"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#840301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#870a08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#911e1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#a13e3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b66a69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#d2a4a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#f4e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1239.73,
    y1: 133.58,
    x2: -1239.66,
    y2: 133.58,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1241.39,
    y1: 133.65,
    x2: -1239.69,
    y2: 133.65,
    gradientTransform: "translate(1241.66 -121.87) rotate(-0.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fbf7f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#f0dfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ddbab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#c48584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#a34342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#840301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -1239.27,
    y1: 134.88,
    x2: -1238.35,
    y2: 133.78,
    gradientTransform: "translate(1241.66 -121.87) rotate(-0.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#840301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#a34342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#c48584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ddbab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f0dfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#fbf7f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1239.47,
    y1: 131.97,
    x2: -1237.51,
    y2: 134,
    gradientTransform: "translate(1241.66 -121.87) rotate(-0.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#840301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#a34342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c48584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#ddbab9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#f0dfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#fbf7f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "313.34 100.01 83.48 116.9 83.91 122.81 313.33 105.03 313.34 100.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "315.11 19.65 314.92 101.01 83.93 118.59 80.22 118.87 82.52 0.13 84.42 0 315.11 19.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "311.91 23.28 311.73 101.47 307.9 101.75 305.15 101.95 301.02 102.26 298.27 102.46 294.14 102.76 291.39 102.97 287.26 103.27 284.51 103.47 280.38 103.78 277.63 103.98 273.5 104.28 270.75 104.48 266.62 104.79 263.87 104.99 259.74 105.29 256.99 105.5 252.87 105.8 250.11 106 245.99 106.31 243.24 106.51 239.11 106.81 236.36 107.01 232.23 107.32 229.48 107.52 225.35 107.82 222.6 108.03 218.47 108.33 215.72 108.53 211.59 108.84 208.84 109.04 204.71 109.34 201.96 109.55 197.83 109.85 195.08 110.05 190.95 110.36 188.2 110.56 184.08 110.86 181.32 111.06 177.2 111.37 174.45 111.57 170.32 111.87 167.57 112.08 163.44 112.38 160.69 112.58 156.56 112.89 153.81 113.09 149.68 113.39 146.93 113.59 142.8 113.9 140.05 114.1 135.92 114.4 133.17 114.61 129.04 114.91 126.29 115.11 122.17 115.41 119.41 115.62 115.29 115.92 112.53 116.12 108.41 116.43 105.66 116.63 101.53 116.93 98.78 117.14 94.65 117.44 91.9 117.64 87.03 118 87.32 4.87 91.9 5.25 94.65 5.47 98.78 5.81 101.53 6.03 105.66 6.37 108.41 6.6 112.53 6.94 115.29 7.16 119.41 7.5 122.17 7.73 126.29 8.06 129.04 8.29 133.17 8.63 135.92 8.85 140.05 9.19 142.8 9.42 146.93 9.76 149.68 9.98 153.81 10.32 156.56 10.55 160.69 10.88 163.44 11.11 167.57 11.45 170.32 11.67 174.45 12.01 177.2 12.24 181.32 12.58 184.08 12.8 188.2 13.14 190.95 13.36 195.08 13.7 197.83 13.93 201.96 14.27 204.71 14.49 208.84 14.83 211.59 15.06 215.72 15.4 218.47 15.62 222.6 15.96 225.35 16.18 229.48 16.52 232.23 16.75 236.36 17.09 239.11 17.31 243.24 17.65 245.99 17.88 250.11 18.21 252.87 18.44 256.99 18.78 259.74 19 263.87 19.34 266.62 19.57 270.75 19.91 273.5 20.13 277.63 20.47 280.38 20.7 284.51 21.03 287.26 21.26 291.39 21.6 294.14 21.82 298.27 22.16 301.02 22.39 305.15 22.73 307.9 22.95 311.91 23.28"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "299 103.57 300.98 103.41 302.97 103.26 304.94 103.1 304.95 98.16 302.52 100.16 301.25 102.22 299 102.39 299 103.57"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M428.81,140.92l3.26.28a.36.36,0,0,1,.29.37v3.73a.28.28,0,0,1-.29.31l-3.26-.25a.36.36,0,0,1-.3-.37v-3.75A.29.29,0,0,1,428.81,140.92Z",
    transform: "translate(-116.94 -121.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M430.44,144.52a1.06,1.06,0,0,0,1.08-1.12s0,0,0,0a1.07,1.07,0,0,1-1.09,1.16,1.3,1.3,0,0,1-1.09-1.34v0A1.29,1.29,0,0,0,430.44,144.52Z",
    transform: "translate(-116.94 -121.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M430.44,142h0a1.31,1.31,0,0,1,1.09,1.34h0a1.07,1.07,0,0,1-1.09,1.16h0a1.3,1.3,0,0,1-1.09-1.34h0A1.07,1.07,0,0,1,430.44,142Z",
    transform: "translate(-116.94 -121.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M428.62,223l3.26-.25a.3.3,0,0,1,.3.32v3.73a.35.35,0,0,1-.3.36l-3.26.28a.29.29,0,0,1-.3-.32V223.4A.35.35,0,0,1,428.62,223Z",
    transform: "translate(-116.94 -121.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M430.25,226.37a1.31,1.31,0,0,0,1.09-1.3v0a1.3,1.3,0,0,1-1.09,1.34,1.06,1.06,0,0,1-1.09-1.16v0A1.07,1.07,0,0,0,430.25,226.37Z",
    transform: "translate(-116.94 -121.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M430.25,223.87h0a1.07,1.07,0,0,1,1.09,1.16h0a1.3,1.3,0,0,1-1.09,1.34h0a1.07,1.07,0,0,1-1.09-1.17h0A1.29,1.29,0,0,1,430.25,223.87Z",
    transform: "translate(-116.94 -121.87)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "94.65 5.47 94.65 117.44 91.9 117.64 91.9 5.25 94.65 5.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "101.53 6.03 101.53 116.93 98.78 117.14 98.78 5.81 101.53 6.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "108.41 6.6 108.41 116.43 105.66 116.63 105.66 6.37 108.41 6.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "115.29 7.16 115.29 115.92 112.53 116.12 112.53 6.94 115.29 7.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "122.17 7.73 122.17 115.41 119.41 115.62 119.41 7.5 122.17 7.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "129.04 8.29 129.04 114.91 126.29 115.11 126.29 8.06 129.04 8.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "135.92 8.85 135.92 114.4 133.17 114.61 133.17 8.63 135.92 8.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "142.8 9.42 142.8 113.9 140.05 114.1 140.05 9.19 142.8 9.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "149.68 9.98 149.68 113.39 146.93 113.59 146.93 9.76 149.68 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "156.56 10.55 156.56 112.89 153.81 113.09 153.81 10.32 156.56 10.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "163.44 11.11 163.44 112.38 160.69 112.58 160.69 10.88 163.44 11.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "170.32 11.67 170.32 111.87 167.57 112.08 167.57 11.45 170.32 11.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "177.2 12.24 177.2 111.37 174.45 111.57 174.45 12.01 177.2 12.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "184.08 12.8 184.08 110.86 181.32 111.06 181.32 12.58 184.08 12.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "190.95 13.36 190.95 110.36 188.2 110.56 188.2 13.14 190.95 13.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "197.83 13.93 197.83 109.85 195.08 110.05 195.08 13.7 197.83 13.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "204.71 14.49 204.71 109.34 201.96 109.55 201.96 14.27 204.71 14.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "211.59 15.06 211.59 108.84 208.84 109.04 208.84 14.83 211.59 15.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "218.47 15.62 218.47 108.33 215.72 108.53 215.72 15.4 218.47 15.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "225.35 16.18 225.35 107.82 222.6 108.03 222.6 15.96 225.35 16.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "232.23 16.75 232.23 107.32 229.48 107.52 229.48 16.52 232.23 16.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "239.11 17.31 239.11 106.81 236.36 107.01 236.36 17.09 239.11 17.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "245.99 17.88 245.99 106.31 243.24 106.51 243.24 17.65 245.99 17.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "252.87 18.44 252.87 105.8 250.11 106 250.11 18.21 252.87 18.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "259.74 19 259.74 105.29 256.99 105.5 256.99 18.78 259.74 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "266.62 19.57 266.62 104.79 263.87 104.99 263.87 19.34 266.62 19.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "273.5 20.13 273.5 104.28 270.75 104.48 270.75 19.91 273.5 20.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "280.38 20.7 280.38 103.78 277.63 103.98 277.63 20.47 280.38 20.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "287.26 21.26 287.26 103.27 284.51 103.47 284.51 21.03 287.26 21.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "294.14 21.82 294.14 102.76 291.39 102.97 291.39 21.6 294.14 21.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "301.02 22.39 301.02 102.26 298.27 102.46 298.27 22.16 301.02 22.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "307.9 22.95 307.9 101.75 305.15 101.95 305.15 22.73 307.9 22.95"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "5.77 14.04 2.91 14.29 2.91 13.75 0.28 13.98 0.28 9.98 3.58 9.67 5.57 9.48 5.77 14.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "0.28 9.98 3.58 9.67 5.57 9.48 5.76 14.02 2.92 14.27 2.9 13.75 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "0.28 9.98 3.58 9.67 5.57 9.48 5.75 13.99 2.92 14.24 2.88 13.75 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "0.28 9.98 3.58 9.67 5.57 9.48 5.74 13.97 2.93 14.21 2.87 13.75 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "0.28 9.98 3.58 9.67 5.57 9.48 5.73 13.94 2.94 14.19 2.85 13.75 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "0.28 9.98 3.58 9.67 5.57 9.48 5.72 13.92 2.94 14.16 2.83 13.75 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "0.28 9.98 3.58 9.67 5.57 9.48 5.71 13.89 2.95 14.13 2.82 13.75 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "0.28 9.98 3.58 9.67 5.57 9.48 5.7 13.87 2.95 14.11 2.8 13.76 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "0.28 9.98 3.58 9.67 5.57 9.48 5.69 13.84 2.96 14.08 2.79 13.76 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "0.28 9.98 3.58 9.67 5.57 9.48 5.68 13.82 2.96 14.05 2.77 13.76 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "0.28 9.98 3.58 9.67 5.57 9.48 5.67 13.79 2.97 14.03 2.76 13.76 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "0.28 9.98 3.58 9.67 5.57 9.48 5.66 13.77 2.98 14 2.74 13.76 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "0.28 9.98 3.58 9.67 5.57 9.48 5.66 13.74 2.98 13.97 2.73 13.76 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "0.28 9.98 3.58 9.67 5.57 9.48 5.64 13.71 2.99 13.95 2.71 13.76 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "0.28 9.98 3.58 9.67 5.57 9.48 5.63 13.69 2.99 13.92 2.69 13.77 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "0.28 9.98 3.59 9.67 5.57 9.48 5.63 13.66 3 13.89 2.68 13.77 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "0.28 9.98 3.59 9.67 5.57 9.48 5.62 13.64 3 13.87 2.66 13.77 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "0.28 9.98 3.59 9.67 5.57 9.48 5.61 13.61 3.01 13.84 2.65 13.77 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "0.28 9.98 3.59 9.67 5.57 9.48 5.6 13.59 3.02 13.81 2.63 13.77 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "0.28 9.98 3.59 9.67 5.57 9.48 5.59 13.56 3.02 13.79 2.62 13.77 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "0.28 9.98 3.59 9.67 5.57 9.48 5.58 13.54 3.03 13.76 2.6 13.77 0.28 13.98 0.28 9.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "5.57 13.51 0.28 13.98 0.28 9.98 5.57 9.48 5.57 13.51"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "2.91 9.63 0.03 9.91 0.03 14.1 2.91 13.85 2.91 9.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "5.57 13.51 0.28 13.98 0.28 9.98 5.57 9.48 5.57 13.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "5.57 11.91 0.28 12.39 0.28 9.98 5.57 9.48 5.57 11.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "2.11 13.82 1.86 13.84 1.86 9.83 2.11 9.81 2.11 13.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "2.02 13.82 1.94 13.83 1.94 9.82 2.02 9.82 2.02 13.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "1.98 13.83 0.28 13.98 0.28 9.98 1.98 9.82 1.98 13.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "4.68 12.91 2.56 13.1 2.56 10.44 4.67 10.24 4.68 12.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "4.68 12.91 2.56 13.1 2.56 10.44 4.67 10.24 4.68 12.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "4.68 12.91 2.56 13.1 2.56 10.44 4.67 10.24 4.68 12.91"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "48.64 121.29 51.41 121.06 54.21 120.84 56.98 120.61 56.99 113.3 53.59 116.26 51.8 119.3 48.64 119.54 48.64 121.29"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "58.37 120.5 61.08 120.28 63.8 120.06 66.5 119.85 66.51 112.63 63.19 115.54 61.45 118.54 58.38 118.78 58.37 120.5"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "67.85 119.74 70.49 119.53 73.14 119.31 75.77 119.1 75.78 111.98 72.55 114.85 70.85 117.81 67.86 118.04 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "67.85 119.74 70.52 119.52 73.15 119.31 75.77 119.1 75.78 112.05 72.56 114.92 70.88 117.84 67.86 118.07 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "67.85 119.74 70.56 119.52 73.17 119.31 75.77 119.1 75.78 112.13 72.58 115 70.91 117.87 67.86 118.11 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "67.85 119.74 70.59 119.52 73.19 119.31 75.77 119.1 75.78 112.2 72.6 115.07 70.95 117.9 67.86 118.14 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "67.85 119.74 70.63 119.52 73.21 119.31 75.77 119.1 75.78 112.28 72.61 115.15 70.98 117.93 67.86 118.18 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "67.85 119.74 70.66 119.51 73.22 119.31 75.77 119.1 75.78 112.36 72.63 115.22 71.01 117.96 67.86 118.21 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "67.85 119.74 70.69 119.51 73.24 119.3 75.77 119.1 75.78 112.43 72.64 115.3 71.04 118 67.86 118.25 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "67.85 119.74 70.73 119.51 73.26 119.3 75.77 119.1 75.78 112.51 72.66 115.37 71.07 118.03 67.85 118.28 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "67.85 119.74 70.76 119.5 73.28 119.3 75.77 119.1 75.78 112.58 72.68 115.45 71.11 118.06 67.85 118.31 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "67.85 119.74 70.8 119.5 73.29 119.3 75.77 119.1 75.78 112.66 72.69 115.52 71.14 118.09 67.85 118.35 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "67.85 119.74 70.83 119.5 73.31 119.3 75.77 119.1 75.78 112.73 72.71 115.6 71.17 118.12 67.85 118.38 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "67.85 119.74 70.87 119.5 73.33 119.3 75.77 119.1 75.78 112.81 72.72 115.67 71.2 118.15 67.85 118.42 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "67.85 119.74 70.9 119.49 73.34 119.3 75.77 119.1 75.78 112.89 72.74 115.75 71.23 118.19 67.85 118.45 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "67.85 119.74 70.94 119.49 73.36 119.29 75.77 119.1 75.78 112.96 72.76 115.82 71.27 118.22 67.85 118.49 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "67.85 119.74 70.97 119.49 73.38 119.29 75.77 119.1 75.78 113.04 72.77 115.9 71.3 118.25 67.85 118.52 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "67.85 119.74 71 119.48 73.39 119.29 75.77 119.1 75.78 113.11 72.79 115.97 71.33 118.28 67.85 118.56 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "67.85 119.74 71.04 119.48 73.41 119.29 75.77 119.1 75.78 113.19 72.8 116.05 71.36 118.31 67.85 118.59 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "67.85 119.74 71.07 119.48 73.43 119.29 75.77 119.1 75.78 113.27 72.82 116.12 71.4 118.34 67.85 118.62 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "67.85 119.74 71.11 119.47 73.45 119.29 75.77 119.1 75.78 113.34 72.84 116.2 71.43 118.38 67.85 118.66 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "67.85 119.74 71.14 119.47 73.46 119.28 75.77 119.1 75.78 113.42 72.85 116.27 71.46 118.41 67.85 118.69 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "67.85 119.74 71.18 119.47 73.48 119.28 75.77 119.1 75.78 113.49 72.87 116.35 71.49 118.44 67.85 118.73 67.85 119.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "67.85 119.74 71.21 119.47 73.5 119.28 75.77 119.1 75.78 113.57 72.88 116.42 71.52 118.47 67.85 118.76 67.85 119.74"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "77.09 118.99 79.66 118.79 82.24 118.58 84.81 118.37 84.82 111.34 81.67 114.17 80.01 117.09 77.09 117.32 77.09 118.99"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0.06 117.07 10.71 113.73 0.07 112.67 0.06 117.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.5,246.63l-1.31-.15a.58.58,0,0,1-.45-.58l-.59-6.57,5.31.37-2.55,6.64A.4.4,0,0,1,169.5,246.63Z",
    transform: "translate(-116.94 -121.87)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "81.85 125.54 68.44 119.72 82 121.08 81.85 125.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.29,243.7l1.2.14c.21,0,.39-.18.42-.47l.54-6.2-4.83-.63,2.3,6.8A.48.48,0,0,0,143.29,243.7Z",
    transform: "translate(-116.94 -121.87)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "84.42 0 83.93 118.59 83.91 122.81 0.06 114.19 0.05 9.05 82.52 0.13 84.42 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "80.71 117.59 2.92 110.23 2.91 12.12 80.7 4.17 80.71 117.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "3.58 12.61 3.61 109.26 38.77 112.52 39.55 112.59 79.82 116.32 79.78 4.7 39.54 9.13 38.76 9.21 3.58 12.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "38.76 9.21 38.77 112.52 39.55 112.59 39.54 9.13 38.76 9.21"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "5.58 107.46 0.29 106.99 0.29 102.99 5.58 103.42 5.58 107.46"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "2.92 103.11 0.04 102.87 0.04 107.06 2.92 107.32 2.92 103.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "5.58 107.46 0.29 106.99 0.29 102.99 5.58 103.42 5.58 107.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "4.58 106.65 2.47 106.47 2.47 103.8 4.58 103.97 4.58 106.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "2.92 76.66 0.03 76.56 0.03 80.75 2.92 80.87 2.92 76.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "5.34 80.89 0.06 80.68 0.06 76.69 5.34 76.85 5.34 80.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "5.03 79.96 2.91 79.88 2.91 77.22 5.03 77.28 5.03 79.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "2.92 40.85 0.03 40.98 0.03 45.17 2.92 45.06 2.92 40.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "5.67 44.84 0.38 45.04 0.38 41.04 5.66 40.8 5.67 44.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "4.58 44.22 2.47 44.3 2.47 41.63 4.58 41.54 4.58 44.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "2.89 13.54 0 13.68 0 17.86 2.89 17.75 2.89 13.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "5.64 17.54 0.35 17.73 0.35 13.74 5.64 13.5 5.64 17.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "4.55 16.91 2.44 17 2.44 14.33 4.55 14.24 4.55 16.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "35.37 24.93 6.62 26.73 7.77 24.93 34.1 23.19 35.37 24.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "35.37 16.8 6.62 19.03 7.77 20.67 34.09 18.72 35.37 16.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "34.1 23.19 34.09 18.72 35.37 16.8 35.37 24.93 34.1 23.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "6.62 26.73 7.77 24.93 7.77 20.67 6.62 19.03 6.62 26.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "35.37 53.37 6.62 53.72 7.77 51.97 34.1 51.56 35.37 53.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "35.37 45.24 6.62 46.01 7.77 47.71 34.1 47.09 35.37 45.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "34.1 51.56 34.1 47.09 35.37 45.24 35.37 53.37 34.1 51.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "6.62 53.72 7.77 51.97 7.77 47.71 6.62 46.01 6.62 53.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "35.37 72.52 6.62 71.89 7.77 70.18 34.1 70.67 35.37 72.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "35.37 64.39 6.62 64.18 7.77 65.92 34.1 66.2 35.37 64.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "34.1 70.67 34.1 66.2 35.37 64.39 35.37 72.52 34.1 70.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "6.62 71.89 7.77 70.18 7.77 65.92 6.62 64.18 6.62 71.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "35.38 100.95 6.62 98.87 7.77 97.22 34.1 99.05 35.38 100.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "35.38 92.83 6.62 91.16 7.77 92.96 34.1 94.58 35.38 92.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "34.1 99.05 34.1 94.58 35.38 92.83 35.38 100.95 34.1 99.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "6.62 98.87 7.77 97.22 7.77 92.96 6.62 91.16 6.62 98.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "42.99 24.45 75.92 22.38 74.46 20.52 44.3 22.52 42.99 24.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "42.98 16.22 75.92 13.67 74.46 15.73 44.3 17.97 42.98 16.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "44.3 22.52 44.3 17.97 42.98 16.22 42.99 24.45 44.3 22.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "75.92 22.38 74.46 20.52 74.46 15.73 75.92 13.67 75.92 22.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "42.99 53.27 75.93 52.88 74.46 50.94 44.3 51.41 42.99 53.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "42.99 45.04 75.92 44.16 74.46 46.15 44.3 46.86 42.99 45.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "44.3 51.41 44.3 46.86 42.99 45.04 42.99 53.27 44.3 51.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "75.93 52.88 74.46 50.94 74.46 46.15 75.92 44.16 75.93 52.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "42.99 72.69 75.93 73.41 74.46 71.43 44.3 70.86 42.99 72.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "42.99 64.45 75.93 64.7 74.46 66.64 44.3 66.31 42.99 64.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "44.3 70.86 44.3 66.31 42.99 64.45 42.99 72.69 44.3 70.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "75.93 73.41 74.46 71.43 74.46 66.64 75.93 64.7 75.93 73.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "42.99 101.51 75.93 103.9 74.47 101.85 44.31 99.75 42.99 101.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "42.99 93.27 75.93 95.19 74.47 97.06 44.31 95.2 42.99 93.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "44.31 99.75 44.31 95.2 42.99 93.27 42.99 101.51 44.31 99.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "75.93 103.9 74.47 101.85 74.47 97.06 75.93 95.19 75.93 103.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "80.71 109.43 84.56 109.74 84.56 114.6 80.71 114.26 80.71 109.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "77.26 113.87 84.21 114.49 84.21 109.86 77.26 109.29 77.26 113.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "78.18 113.29 80.95 113.53 80.95 110.47 78.18 110.25 78.18 113.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "80.71 79.08 84.55 79.2 84.55 84.06 80.71 83.91 80.71 79.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "77.23 83.66 84.19 83.93 84.19 79.3 77.23 79.08 77.23 83.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "77.57 82.94 80.33 83.04 80.33 79.98 77.57 79.89 77.57 82.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "80.71 37.71 84.55 37.53 84.55 42.39 80.71 42.54 80.71 37.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "77.23 42.58 84.18 42.32 84.18 37.69 77.23 38 77.23 42.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "78.08 41.72 80.84 41.61 80.84 38.55 78.08 38.67 78.08 41.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "81.05 5.65 84.88 5.37 85.02 10.23 81.18 10.48 81.05 5.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "77.71 10.62 84.65 10.16 84.52 5.54 77.58 6.05 77.71 10.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "78.53 9.74 81.29 9.55 81.2 6.49 78.44 6.69 78.53 9.74"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg45);
export default __webpack_public_path__ + "static/media/45.99d5fa455ca59b0a660e0a686727f762.svg";
export { ForwardRef as ReactComponent };